import { BarChartTooltipOverlay } from '../BarChartTooltipOverlay/BarChartTooltipOverlay';
import { useRankingChartData } from './hooks/useRankingChartData';

import type { BarChartValue } from '../BarChart/BarChart';

export interface RankingOptionAnswer {
    /** Option label */
    label: string;
    /** Number of responses */
    count: number;
}

export interface RankingQuestionResultProps {
    /** Ranking options with counts */
    options: RankingOptionAnswer[];
    /** Optional class override */
    className?: string;
    /** Test id */
    dataTestId?: string;
}

/**
 * RankingQuestionResult
 *
 * Displays ranking question results using a bar chart.
 * Options are displayed in natural order with dynamic Y-axis.
 */
const RankingQuestionResult = ({
    options,
    className = '',
    dataTestId = 'ranking-question-result',
}: RankingQuestionResultProps) => {
    const { barValues, yAxisConfig } = useRankingChartData(options);

    const renderTooltipContent = (barValue: BarChartValue) => `${barValue.value}%`;

    return (
        <div
            className={`w-full ${className}`}
            data-testid={dataTestId}
        >
            <BarChartTooltipOverlay
                values={barValues}
                yValues={yAxisConfig.yValues}
                maxYValue={yAxisConfig.maxYValue}
                minYValue={yAxisConfig.minYValue}
                dataTestId={`${dataTestId}-chart`}
                renderTooltipContent={renderTooltipContent}
            />
        </div>
    );
};

export { RankingQuestionResult };
export default RankingQuestionResult;
